import { useEffect, useState } from 'react';
import { serviceHost } from '@services';

type UseAnonymousAuthState = {
  uid: string | null;
  isLoading: boolean;
  error: string | null;
};

export const useAnonymousAuth = (): UseAnonymousAuthState => {
  const [state, setState] = useState<UseAnonymousAuthState>({
    uid: null,
    isLoading: true,
    error: null,
  });

  useEffect(() => {
    let isMounted = true;

    const authenticate = async () => {
      try {
        const uid = await serviceHost
          .getAuthenticationService()
          .ensureAnonymousSignIn();

        if (!isMounted) {
          return;
        }

        setState({
          uid,
          isLoading: false,
          error: null,
        });
      } catch (error) {
        if (!isMounted) {
          return;
        }

        const message =
          error instanceof Error
            ? error.message
            : 'Failed to authenticate with Firebase';

        setState({
          uid: null,
          isLoading: false,
          error: message,
        });
      }
    };

    void authenticate();

    return () => {
      isMounted = false;
    };
  }, []);

  return state;
};
